import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { StockForm } from '../../forms/stock.form';
import { markControlsAsTouched } from '../../functions/mark-controls-as-touched';

@Component({
  selector: 'app-add-to-stock-modal',
  templateUrl: './add-to-stock-modal.component.html',
  styleUrls: ['./add-to-stock-modal.component.scss'],
  standalone: false,
})
export class AddToStockModalComponent implements OnInit, OnDestroy {
  form: StockForm;

  private subscription = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<AddToStockModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      id: string;
      currentStock: number;
    }
  ) {
    this.form = new StockForm(this.data.id, this.data.currentStock);
  }

  ngOnInit(): void {
    this.subscription.add(
      this.form.amount.valueChanges.subscribe((amount: number | string) => {
        const parsedAmount = parseFloat(String(amount)) || 0;
        const parsedCurrentStock = parseFloat(String(this.form.currentStock.value)) || 0;
        this.form.newStock.setValue(parsedCurrentStock + parsedAmount);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  save(): void {
    markControlsAsTouched(this.form);

    if (!this.form.valid) {
      return;
    }

    this.dialogRef.close(this.form.value);
  }
}
